import type { QueryClient } from '@tanstack/react-query';

/**
 * Corals are placed once per aquarium photo and shared by every light and flow
 * map on it. After a coral was added, moved or removed on one map, the other
 * maps of the aquarium (and the placement assistant) read them again.
 */
export function invalidateSharedCorals(queryClient: QueryClient, aquariumId: string): void {
  for (const root of ['light-surveys', 'flow-surveys', 'coral-placement']) {
    void queryClient.invalidateQueries({ queryKey: [root, aquariumId] });
  }
}
